<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Relatórios</label>
                    <el-select v-model="tipo">
                        <el-option :key="1" label="GERAL" :value="1"></el-option>
                        <el-option :key="2" label="SERVIDORES - RH (SIP)" :value="2"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <div class="u-mt-10">
            <geral v-if="tipo == 1"></geral>
            <sip v-if="tipo == 2" @sem-acesso="tipo = 1"></sip>
        </div>

        
    </div>
</template>
<script>

import geral from "./geral"
import sip from "./sip"

export default {
    data: () => ({
        tipo: 2        
    }),
    mounted () {

    },
    methods: {     
        text(){

            
        }
    },
    components:{ geral, sip }
}
</script>